// const baseurl = "http://localhost:<SCODE>"
const baseurl = "https://inven-cell.com";

export default baseurl;
//The code is added to work with prod mode...